import { render, staticRenderFns } from "./IntranetClaimPage.vue?vue&type=template&id=61ac924a&"
import script from "./IntranetClaimPage.vue?vue&type=script&lang=js&"
export * from "./IntranetClaimPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports